import { FC, useState, useEffect, ComponentType } from "react"
import UserGeneral from "../components/user/UserGeneral"
import { User, UsersService } from "../sdk"
import { useUser } from "../stores/user"
import { useParams } from "react-router-dom"
import useError from "../hooks/useError"
import PageLoader from "../components/PageLoader"
import Tag from "../components/Tag"
import classNames from "classnames"
import UserSubscriptions from "../components/user/UserSubscriptions"

type SectionId = "general" | "subscriptions"

type SectionsMap = {
  [key in SectionId]: Section
}

export type UserSectionProps = {
  user: User
}

type Section = {
  id: SectionId
  label: string
  component: ComponentType<UserSectionProps>
}

const sections: Section[] = [
  {
    id: "general",
    label: "Generale",
    component: UserGeneral
  },
  {
    id: "subscriptions",
    label: "Iscrizioni",
    component: UserSubscriptions
  }
]

const sectionsMap = sections.reduce((sections: SectionsMap, section: Section) => {
  sections[section.id] = section
  return sections
}, {} as SectionsMap)

const UserPage: FC = () => {
  const user = useUser(state => state.user)
  const setUser = useUser(state => state.setUser)
  const reset = useUser(state => state.reset)

  const [loading, setLoading] = useState<boolean>(true)
  const [activeSection, setActiveSection] = useState<SectionId>("general")

  const Section = sectionsMap[activeSection].component

  const { id: userId } = useParams()
  const { handleError } = useError()

  const getUser = async(): Promise<void> => {
    try {
      const { data: userData } = await UsersService.getUser({
        handler: {
          userId: Number(userId)
        }
      })
      setUser(userData as User)
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!user) {
      void getUser()
    }

    return (): void => {
      reset()
    }
  }, [])

  return (
    <>
      {loading ?
        <PageLoader className="relative mt-16" />
        :
        <div>
          {user ?
            <>
              <div className="flex items-center gap-x-4 mb-10">
                <h1 className="text-4xl font-bold">Utente <span className="text-indigo-700">{user.username}</span></h1>
                {user.admin &&
                  <Tag>Admin</Tag>
                }
              </div>

              <ul className="tabs__nav">
                {sections.map(section => (
                  <li
                    key={section.id}
                    className={classNames("tabs__item", section.id === activeSection && "tabs__item--active")}
                    onClick={(): void => setActiveSection(section.id)}
                  >
                    {section.label}
                  </li>
                ))}
              </ul>

              <div className="tabs__section">
                <Section user={user} />
              </div>
            </>
            :
            <p className="text-red-600 font-semibold">Errore: Utente non trovato</p>
          }
        </div>
      }
    </>
  )
}

export default UserPage